import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';

import { stopEnterSubmit } from '@/utils/forms.js';
import FormFieldBottom from './field-bottom';

export default class FormField extends Component {
    render() {
        const { label, type, input, placeholder, required, meta, note, correct, variant, name } = this.props;
        const fieldError = meta.error || meta.submitError;
        const hasError = (meta.touched || meta.submitFailed) && fieldError;

        const useOutlined = variant === 'outlined';
        const classes = hasError ? "form-field error" : "form-field";
        const fieldClasses = useOutlined ? `${classes} form-input` : classes;

        return (
            <div className={fieldClasses}>
                <label className={required ? "label label_required" : "label"}>{label}</label>
                {useOutlined ? (
                    <TextField
                        fullWidth
                        variant="outlined"
                        placeholder={placeholder}
                        type={type || 'text'}
                        value={input.value ?? ''}
                        onChange={(e) => input.onChange(e.target.value !== undefined ? e.target.value : e)}
                        onBlur={input.onBlur}
                        onKeyDown={stopEnterSubmit}
                        name={input.name || name}
                        autoComplete="off"
                        InputProps={{
                            className: 'form-input__control',
                        }}
                    />
                ) : (
                    <input
                        {...input}
                        placeholder={placeholder}
                        type={type}
                        onKeyDown={stopEnterSubmit}
                        className="signup-form-input"
                        autoComplete="off"
                    />
                )}

                {hasError && <FormFieldBottom meta={{...meta, error: fieldError}} note={note} correct={correct} />}
            </div>
        );
    }
}
